import { formatCurrency } from "util/format";
import { Button, Dropdown, Space } from "antd";
import { DownOutlined } from "@ant-design/icons";
import { notificationErroInternal } from "util/api-utils";
import moment from "moment";

const items = [
  {
    key: "bank",
    label: <a> Bancos </a>,
  },
  {
    key: "edit",
    label: <a> Editar </a>,
  },
  {
    key: "inactive",
    label: <a> Desativar </a>,
  },
  {
    key: "import",
    label: <a> Importar Dados </a>,
  },
  {
    key: "import-plan",
    label: <a> Importar Plano </a>,
  },
];

export const ColumnsClient = [
  {
    title: "CNPJ",
    dataIndex: "document",
    width: "15%",
    ellipsis: true,
  },
  {
    title: "Cliente",
    dataIndex: "name",
    textWrap: "word-break",
    ellipsis: true,
  },
  {
    title: "Tipo",
    dataIndex: "integrationType",
    textWrap: "word-break",
    ellipsis: true,
    width: "10%",
  },
  {
    title: "Status",
    dataIndex: "activeString",
    width: "8%",
  },
  {
    title: "Última Integração",
    dataIndex: "lastIntegration",
    width: "15%",
  },

  {
    title: "Status Integração",
    dataIndex: "statusLastIntegration",
    width: "15%",
  },
  {
    title: "Ações",
    dataIndex: "action",
    render: (text, row) => {
      return (
        <Dropdown
          menu={{
            items,
            onClick: (event) => {
              if (
                event.key == "import" &&
                (row.integrationType == "IMPORT" )
              ) {
                notificationErroInternal(
                  "Para importar dados desse cliente, use a sessão de importação de dados"
                );
                return;
              }
              if (
                event.key == "import-plan" &&
                !(row.integrationType == "CONTA_AZUL")
              ) {
                notificationErroInternal(
                  "Essa funcionalidade está disponivel somente Conta Azul"
                );
                return;
              }

              switch (event.key) {
                case "bank":
                  row.newBank(row);
                  break;
                case "edit":
                  row.edit(row);
                  break;
                case "inactive":
                  row.disable(row);
                  break;
                case "import":
                  row.import(row);
                  break;
                case "import-plan":
                  row.importPlan(row);
                  break;
                default:
                  break;
              }
            },
          }}
        >
          <a>
            <Space>
              Configurações
              <DownOutlined />
            </Space>
          </a>
        </Dropdown>
        /* <Space size="middle">
          <a onClick={() => row.newBank(row)} type="primary">
            Bancos
          </a>
          <a onClick={() => row.edit(row)} type="primary">
            Editar
          </a>
          <a onClick={() => row.disable(row)} type="primary">
            Desativar
          </a>
          {(row.integrationType == "OMIE" ||
            row.integrationType == "EVERFLOW") && (
            <a onClick={() => row.disable(row)} type="primary">
              Importar
            </a>
          )}
        </Space>*/
      );
    },
  },
];

export const ColumnsClientBank = [
  {
    title: "Banco",
    dataIndex: "name",
    ellipsis: true,
  },
  {
    title: "Código Conta",
    dataIndex: "codeAccount",
    ellipsis: true,
  },
  {
    title: "Conta",
    dataIndex: "description",
    ellipsis: true,
  },
  {
    title: "Saldo Inicial",
    dataIndex: "balance",
    textWrap: "word-break",
    ellipsis: true,
    render: (text) => {
      return formatCurrency(text);
    },
  },
  {
    title: "Limite",
    dataIndex: "limit",
    textWrap: "word-break",
    ellipsis: true,
    render: (text) => {
      return formatCurrency(text);
    },
  },
  {
    title: "Data Saldo",
    dataIndex: "dateBalance",
    textWrap: "word-break",
    ellipsis: true,
  },

  {
    title: "Ações",
    dataIndex: "action",
    render: (text, row) => {
      return (
        <Space size="middle">
          <a onClick={() => row.edit(row)} type="primary">
            Editar
          </a>
          <a onClick={() => row.disable(row)} type="primary">
            Excluir
          </a>
        </Space>
      );
    },
  },
];

export const ColumnsClientCsv = [
  {
    label: "CNPJ",
    key: "document",
  },
  {
    label: "Cliente",
    key: "name",
  },
  {
    label: "Tipo",
    key: "integrationType",
  },
  {
    label: "Status",
    key: "activeString",
  },
  {
    label: "Código do banco",
    key: "codeAccount",
  },
  {
    label: "Conta",
    key: "description",
  },
];
